import './style.css'
import moment from 'moment'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { RxHamburgerMenu } from 'react-icons/rx'
import Sidebar from '../../components/Common/Sidebar/Sidebar'
import AdminProfile from '../../components/AdminProfile/AdminProfile'
import MobileSideBar from '../../components/MobileSideBar/MobileSideBar'
import OrderTable from '../../components/OrderTable/OrderTable'
import Pagination from '../../components/Pagination/Pagination'
import useOrderFilters from '../../hooks/useOrdersFilters'
import { formatName, orderStatusOptions } from '../../utils'
import CustomDatePicker from '../../components/atoms/Input/CustomDatePicker'
import FormInput from '../../components/atoms/Input/Form-Input'
import { useUserContext } from '../../context/UserContext'

function BrandOrders() {
  const itemsPerPage = 10
  const [isOpen, setIsOpen] = useState(false)
  const [toggle, setToggle] = useState(false)
  const [orderStatus, setOrderStatus] = useState([])
  const [customerName, setCustomerName] = useState('')
  const [dateRange, setDateRange] = useState({ start: null, end: null })

  const { userData } = useUserContext()
  const isManufacturer =
    userData?.brand !== 'saddlefitadmin' && (userData?.type === 'Admin' || userData?.type === 'Member')
  const { brandSlug } = useParams()

  console.log('brandSlug from URL:', brandSlug)

  const handleStartDateChange = date => {
    setDateRange(prev => ({ ...prev, start: date }))
  }

  const handleEndDateChange = date => {
    setDateRange(prev => ({ ...prev, end: date }))
  }

  const startDateIsValid = currentDate => {
    if (dateRange.end) {
      const end = moment(dateRange.end, 'MM-DD-YYYY')
      return currentDate.isSameOrBefore(end, 'day')
    }
    return true
  }

  const endDateIsValid = currentDate => {
    if (dateRange.start) {
      const start = moment(dateRange.start, 'MM-DD-YYYY')
      return currentDate.isSameOrAfter(start, 'day')
    }
    return true
  }

  const filters = { customerName, dateRange, orderStatus }

  const { state, actions } = useOrderFilters(itemsPerPage, filters)

  return (
    <div className="w-full h-[100%] flex">
      <Sidebar />
      <div className="admin-dashboard-card-section mx-auto order-section xl:ml-[290px] w-[100%] xl:w-[80%]">
        <div className="w-[90%] lg:w-[95%] h-auto mx-auto mt-[45px] flex justify-between items-center">
          <div className="xl:hidden block" onClick={() => setToggle(!toggle)}>
            <RxHamburgerMenu className="w-5 h-5" />
          </div>
          {toggle && <MobileSideBar toggle={toggle} setToggle={setToggle} />}
          <AdminProfile setIsOpen={setIsOpen} isOpen={isOpen} />
        </div>
        <div className="w-[90%] md:w-[95%] pb-[50px] mt-[10px] h-[100%] mx-auto">
          <h1 className="admin-dashboard">Orders</h1>
          <h4 className="status m-0 my-5">Filter Orders</h4>
          <div className="w-full mt-2 mb-4 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div />
            <div className="flex flex-col sm:flex-row md:flex-nowrap items-end gap-6 w-full md:w-auto">
              <CustomDatePicker
                clearable
                value={dateRange.start}
                onChange={handleStartDateChange}
                label="Start Date"
                placeholder="Select Date"
                isValidDate={startDateIsValid}
                inputClassName="font-montserrat text-[14px] w-[95%] sm:w-[80%] md:w-auto px-3 sm:px-5 h-[50px] mt-2 rounded-[50px] border border-[#999]"
                className="w-full md:!w-[195px]"
              />

              <CustomDatePicker
                clearable
                value={dateRange.end}
                onChange={handleEndDateChange}
                label="End Date"
                placeholder="Select Date"
                isValidDate={endDateIsValid}
                inputClassName="font-montserrat text-[14px] w-[95%] sm:w-[80%] md:w-auto px-3 sm:px-5 h-[50px] mt-2 rounded-[50px] border border-[#999]"
                className="w-full md:!w-[195px]"
              />

              <FormInput
                isMulti
                name="discipline"
                type="select2"
                label="By Order Status"
                height={52}
                placeholder="Select Order Status"
                value={orderStatus}
                options={orderStatusOptions}
                onChange={options => setOrderStatus(options)}
                className="w-full md:!w-[195px]"
              />
            </div>
          </div>
          <div className="md:flex justify-between flex-wrap items-center my-5">
            <h4 className="status m-0">
              {isManufacturer
                ? formatName(userData?.brand)
                : formatName(brandSlug)}
              Orders
            </h4>
          </div>
          <div className="min-h-[200px] mt-0 overflow-x-scroll tableContainer">
            <OrderTable orders={state.orders} loading={state.loading} />
          </div>
          <Pagination
            loadNextPage={actions.loadNextPage}
            loadPreviousPage={actions.loadPreviousPage}
            canLoadNext={state.canLoadNext}
            canLoadPrevious={state.canLoadPrevious}
          />
        </div>
      </div>
    </div>
  )
}

export default BrandOrders
